import React from "react";
import { Link } from "react-router-dom";
import "./ProcessStepCard.css";

const ProcessCard = ({ stepNumber, title, descriptionPoints, titleColor }) => {
  const titleStyle = {
    color: titleColor,
  };
  //style={titleStyle}
  return (
    <div className="process-card-clean">
      <h3 className="process-card-title">
        <span className="step-number_">{stepNumber}.</span> {title}
      </h3>
      <ul className="process-card-list">
        {descriptionPoints.map((point, index) => {
          const linkMatch = point.match(/see (Sample Catalog)\./);
          if (linkMatch) {
            
            let preText = point.split(linkMatch[0])[0];
          preText = preText.replace('(', "");
            return (
              <li style={{display:"inline"}} key={index}>
                {preText}see <Link to="/sample-catalog">{linkMatch[1]}</Link>.
              </li>
            );
          }
          return <li key={index}>{point}</li>;
        })}
      </ul>
    </div>
  );
};

export default ProcessCard;
